import { render } from "./DonatursPrayCell.vue?vue&type=template&id=4ca284aa"
import script from "./DonatursPrayCell.vue?vue&type=script&lang=js"
export * from "./DonatursPrayCell.vue?vue&type=script&lang=js"
script.render = render

export default script